<template>
    <v-card class="rounded-4"> 
        <v-toolbar flat height="45px">  
            <b>Employment Update History</b>
            <v-spacer></v-spacer>  
            <v-btn icon @click.native="closeDialog()" >
                <v-icon >close</v-icon>
            </v-btn>                      
        </v-toolbar>
        
        <v-card-text>
            <v-data-table
                :headers="headers"
                :items="history"
                :loading="loading"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="paginationSync"
            >
                <template v-slot:items="props">
                    <tr>
                        <td>{{ props.item.effectiveDate | moment('MMM DD, YYYY') }}</td>
                        <td>{{commonfn.getStatusDescription(props.item.employmentStatus)}}</td>
                        <td>{{commonfn.getStatusDescription(props.item.employmentType)}}</td>
                        <td>{{commonfn.getStatusDescription(props.item.workArrangement)}}</td>
                        <td>
                            <span v-if="props.item.roleCategory">{{commonfn.getStatusDescription(props.item.roleCategory)}}</span>
                        </td>
                        <td>
                            <span class="nowrap-text">{{ props.item.position }}</span>
                        </td>
                        <td>
                            <div class="nowrap-text">{{ props.item.startDate | moment('MMM DD, YYYY') }}</div>
                        </td>
                        <td v-if="hasResignedOrTerminatedRecord">{{ props.item.endDate | moment('MMM DD, YYYY') }}</td>                    
                        <td>{{ commonfn.getSalaryTypeName(props.item.salaryType) }}</td>
                        <td>{{ props.item.workEmail }}</td>
                        <td>{{ props.item.tin }}</td>
                        <td>{{ props.item.sss }}</td>
                        <td>{{ props.item.pagibig }}</td>
                        <td>{{ props.item.philhealth }}</td>
                        <td>
                            <div class="nowrap-text">{{ props.item.createdOn | moment('MMM DD, YYYY h:mma') }}</div>
                        </td>
                        <td>
                            <v-chip small class="user-chip-container">
                                <v-avatar>
                                    <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.createdByUser.userId)"></v-img>
                                </v-avatar>
                                {{props.item.createdByUser.firstName}} {{props.item.createdByUser.lastName}}
                            </v-chip>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card-text>

    </v-card>
</template>
<script>

import employmentApi from '@/api/employment'
import commonfn from '@/common/functions'   //for refactor
import { getSort, getRowsPerPage, updateRowsPerPage, updateSort } from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'
import awsS3Helper from '@/helpers/aws-s3'

export default {
    data () {
        const routeName = `${this.$route.name}-ViewEmploymentUpdateHistoryPopup`
        const savedSort = getSort(routeName)
        
        return {
            awsS3Helper,
            commonfn,
            rowsPerPageItems,
            error: false,
            errorMessage: null,
            loading: false,
            disabled: false,
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },            
            history: []
        }   
    },
    methods: {
        async getEmploymentUpdateHistory(userId) {
            try {
                this.loading = true
                const response = await employmentApi.getHistoryByUser(userId)
                if (response && response.status == 200) {
                    this.history = response.data.items
                }
                 this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        closeDialog() {
            this.$emit('update:dialogEmploymentHistory', false)
        },
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(`${this.$route.name}-ViewEmploymentUpdateHistoryPopup`, newVal);
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(`${this.$route.name}-ViewEmploymentUpdateHistoryPopup`, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(`${this.$route.name}-ViewEmploymentUpdateHistoryPopup`, this.paginationSync.sortBy, newVal)
        },
    },
    computed: {
        hasResignedOrTerminatedRecord() {
            return this.history.find(x => {
                return x.employmentStatus == commonfn.getStatusCode('Resigned') ||
                    x.employmentStatus == commonfn.getStatusCode('Terminated')
            })
        },
        headers() {
            const header =  [
                {text: 'Effective Date', align: 'left', value: 'effectiveDate', width:'2%', sortable:true},
                {text: 'Status', align: 'left', value: 'employmentStatus', width:'2%', sortable:true},
                {text: 'Type', align: 'left', value: 'employmentType', width:'2%', sortable:true},
                {text: 'Work Arrangement', align: 'left', value: 'workArrangement', width:'5', sortable:true},
                {text: 'Role Category', align: 'left', value: 'roleCategory', width:'2%', sortable:true},
                {text: 'Position', align: 'left', value: 'position', width:'20%', sortable:true},
                {text: 'Start Date', align: 'left', value: 'startDate', width:'2%', sortable:true},                
            ]
            if (this.hasResignedOrTerminatedRecord) {
                header.push({text: 'End Dt', align: 'left', value: 'endDate', width:'2%', sortable:true})
            }
            header.push({text: 'Salary Type', align: 'left', value: 'salaryType', width: '2%', sortable:true})
            header.push({text: 'Work Email', align: 'left', value: 'workEmail', width: '2%', sortable:true})
            header.push({text: 'TIN', align: 'left', value: 'tin', width: '2%', sortable:true})
            header.push({text: 'SSS', align: 'left', value: 'sss', width: '2%', sortable:true})
            header.push({text: 'Pag-IBIG', align: 'left', value: 'pagibig', width: '2%', sortable:true})
            header.push({text: 'PhilHealth', align: 'left', value: 'philhealth', width: '2%', sortable:true})
            header.push({text: 'Created On', align: 'left', value: 'createdOn', width: '2%', sortable:true})
            header.push({text: 'Created By', align: 'left', value: '', width: '2%', sortable:false})

            return header
        }
    }
}
</script>